import { FieldTypes } from '../../constants'
import {
  BooleanField,
  DateTimeField,
  DropdownField,
  FieldMap,
  MultipleSelectField,
  TextAreaField,
  TextField,
} from '../../types'
import { NarrativeCategory } from '../types'

const timestampField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'Time of Event',
  defaultToNow: true,
}

const noteBodyField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Note',
  withDotPhrases: true,
}

const categoryField: DropdownField<NarrativeCategory> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Category',
  inputType: 'radio',
  options: [
    { text: 'General', id: NarrativeCategory.GENERAL },
    { text: 'Procedure', id: NarrativeCategory.PROCEDURE },
    { text: 'Consent', id: NarrativeCategory.CONSENT },
    { text: 'Emergency', id: NarrativeCategory.EMERGENCY },
    { text: 'Family Communication', id: NarrativeCategory.FAMILY_COMM },
  ],
}

const tagsField: MultipleSelectField = {
  type: FieldTypes.MULTIPLE_SELECT,
  placeholder: 'Tags',
  optional: true,
  options: [
    { text: 'Position Change', id: 'position_change' },
    { text: 'Hydrotherapy', id: 'hydrotherapy' },
    { text: 'Aromatherapy', id: 'aromatherapy' },
    { text: 'Ambulation', id: 'ambulation' },
    { text: 'IV Placement', id: 'iv_placement' },
    { text: 'Fetal Monitoring', id: 'fetal_monitoring' },
  ],
}

const isAmendedField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Amendment',
  inputType: 'radio',
  yesText: 'This is an amendment',
  noText: 'Original note',
  optional: true,
}

const parentNoteIdField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Original Note ID',
  optional: true,
  condition: v => !!v?.isAmended,
}

export const narrativeField: FieldMap = {
  name: 'Narrative Note',
  children: {
    timestamp: timestampField,
    category: categoryField,
    noteBody: noteBodyField,
    tags: tagsField,
    isAmended: isAmendedField,
    parentNoteId: parentNoteIdField,
  },
}
